module.exports = __webpack_public_path__ + "media/images/pic/intensivity_companies-23d56643127e22a32021572cdf9b108d.svg";